<template>
  <header class="main-header">
      <div class="container">
          <div class="row">
              <div class="col-4 text-left breadcrumbs"><a href="#" class="color--blue">Sekretariat</a> / Teilnehmer</div>
              <div class="col text-right menu__right">
                  <a href="#" class="color--blue"><i class="icon--circle icon--bg">&nbsp;<span class="icon--fontFix">+</span></i> Neu</a>
                  <a href="#" class="color--blue"><i class="icon--circle icon--bg">&nbsp;<span>1</span></i> Nachricht</a>
                  <div class="dropdown display--inline-block">
                      <button class="button__raw dropdown-toggle color--blue" type="button" id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Dropdown
                      </button>
                      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu">
                          <button class="dropdown-item" type="button">Action</button>
                          <button class="dropdown-item" type="button">Another action</button>
                          <button class="dropdown-item" type="button">Something else here</button>
                      </div>
                  </div>
                  <form class="form-inline form__search color--blue display--inline-block">
                      <i class="material-icons">search</i>
                      <input class="form-control input__search border--blue placeholder--blue" type="search" placeholder="Search" aria-label="Search">
                      <i class="material-icons">close</i>
                  </form>
              </div>
          </div>
          <div class="row">
              <h1 class="col text-left color--blue">Dr. med. dent. Dominic Plüss</h1>
          </div>
          <div class="row">
              <a href="#" class="menu__burger color--blue d-none">
                <span class="opener"
                      v-on:click="toggleMenu">
                    <i class="material-icons">menu</i>
                </span>
                <span class="closer"
                    v-on:click="toggleMenu">
                    <i class="material-icons">close</i>
                </span>
              </a>
              <div class="col text-left menu__main" v-bind:class="{active: isOpen}">
                  <a href="#" class="active color--blue">Verwalten</a>
                  <a href="#">Erreichbarkeit</a>
                  <a href="#">Erweitert</a>
                  <a href="#">Beantworter</a>
                  <a href="#">E-Mail Einstellungen</a>
                  <a href="#">Ferien/Stv.</a>
                  <a href="#">Optionen</a>
                  <a href="#">Import</a>
                  <a href="#">Export</a>
              </div>
          </div>
      </div>
  </header>
</template>

<script>
    export default {
        name: 'TopBar',
        data () {
            return {
                isOpen: false
            }
        },
        methods: {
            toggleMenu: function(){
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>

<style lang="scss">
  @import "./../assets/scss/_base.scss";
  header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 19;
      padding: 1rem 0;
      padding-bottom: 11px;
      background-color: $secondary_colour;
      background-image: url('./../assets/bg.jpg');

      > .container {
          transition: all .3s ease-in-out;
      }
  }

  .breadcrumbs {
      color: white;
  }

  .menu__right > * {
      margin-left: 1rem;
  }

  .menu__main {
      a {
          padding: 0 3px;
          @media #{$laptop_break} {
              padding: 0 10px;
          }
      }
      .active {
          padding-bottom: 5px;
          border-bottom: 5px solid $blue;
      }
      @media #{$netbook_bootstrap_break_before}{
          display: none;
          &.active {
            display: block;
          }
          a {
              padding: 7px 5px;
              width: 100%;
              text-align: center;
              display: block;
              &.active {
                   border-bottom: none;
              }
          }
      }
  }

  .logo img {
      width: 100%;
      padding: 2rem 3rem;
      padding-right: 5rem
  }

   /*.menu__burger {*/
      /*display: none;*/
   /*}*/
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue